import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'authorizations-filter-buttons',
  templateUrl: './authorizations-filter-buttons.component.html',
  styleUrls: ['./authorizations-filter-buttons.component.css']
})
export class AuthorizationsFilterButtonsComponent implements OnInit {
  @Input() isResident: boolean = false;
  @Input() isEmployee: boolean = false;
  @Input() isServiceProvider: boolean = false;
  @Input() isVisitor: boolean = false; 
  @Input() allowedRoles: string[] = [];
  @Output() updateMultiSelectGroupAuthRole: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
    console.log('AuthorizationsFilterButtonsComponent initialized with allowedRoles:', this.allowedRoles);
  }

  updateMultiSelectGroupAuthRoleEmit(role: string): void {
    this.updateMultiSelectGroupAuthRole.emit(role); 
  }

}
